// components/CarPrinterPopup.tsx
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PrintContent from "./PrintContent";
import PrinterActions from "./PrinterActions";
import { useBusinessInfo } from "../hooks/useBusinessInfo";

interface CarPrinterPopupProps {
  orderData: any;
  onClose: () => void;
}

const CarPrinterPopup: React.FC<CarPrinterPopupProps> = ({ orderData, onClose }) => {
  const [hasPrinted, setHasPrinted] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const { businessPrint, organizationData } = useBusinessInfo();
  const navigate = useNavigate();

  const handlePrint = () => {
    if (isPrinting) return;

    setIsPrinting(true);

    setTimeout(() => {
      window.print();
      setHasPrinted(true);

      setTimeout(() => {
        setIsPrinting(false);
        onClose();
        navigate("/v1/new-order");
      }, 500);
    }, 300);
  };

  const handleWhatsAppShare = () => {
    const { CustomerName, Orderid, totalOrderPrice } = orderData;
    const message = `Order Details:\nCustomer: ${CustomerName}\nOrder ID: ${Orderid}\nTotal: ₹${totalOrderPrice}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
    onClose();

    setTimeout(() => {
      navigate("/v1/new-order");
    }, 800);
  };

  return (
    <div className="text-center">
      <p className="text-gray-700 mb-2">Customer: {orderData.CustomerName}</p>
      <p className="text-gray-700 mb-6">Total Amount: {orderData.totalAmount}</p>

      <PrinterActions onWhatsAppClick={handleWhatsAppShare} onPrintClick={handlePrint} isPrinting={isPrinting} />

      <div className="hidden print:block">
        <PrintContent orderData={orderData} orderId={orderData.Id} businessPrint={businessPrint} organizationData={organizationData} />
      </div>
    </div>
  );
};

export default CarPrinterPopup;
